import { useState } from "react";
import { ShoppingCart } from "lucide-react";
import { GATEWAYS, extractCID } from "../utils/ipfs";

interface Props {
  tokenId:   number | bigint;
  image:     string;          // ipfs:// URI  OR  full HTTPS URL
  name:      string;
  className?: string;
  isGenesis?: boolean;
}

export default function NFTImage({ tokenId, image, name, className = "", isGenesis = false }: Props) {
  const [gatewayIdx, setGatewayIdx] = useState(0);
  const [failed,     setFailed]     = useState(false);

  const buildUrl = (idx: number): string => {
    if (!image) return "";
    const cid = extractCID(image);
    if (!cid) return image;
    return (GATEWAYS[idx] ?? GATEWAYS[0]) + cid;
  };

  const src = buildUrl(gatewayIdx);

  const handleError = () => {
    const next = gatewayIdx + 1;
    if (next < GATEWAYS.length) setGatewayIdx(next);
    else setFailed(true);
  };

  // Genesis NFT: wide landscape container (aspect-video 16:9) so the full
  // opendime USB stick + Bitcoin logo disc is visible without cropping.
  // Other NFTs: taller 4:3 container works for most artwork.
  const containerClass = isGenesis
    ? "aspect-video"
    : "aspect-[4/3]";

  return (
    <div className={`${containerClass} relative overflow-hidden bg-white ${className}`}>
      {!failed && src ? (
        <img
          key={`${String(tokenId)}-gw${gatewayIdx}`}
          src={src}
          alt={name}
          className="w-full h-full object-contain"
          onError={handleError}
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-gray-100">
          <div className="text-center text-gray-400">
            <ShoppingCart className="w-16 h-16 mx-auto mb-2" />
            <p className="text-sm">Image unavailable</p>
          </div>
        </div>
      )}
    </div>
  );
}
